import React from "react";
import { FieldProps } from "../../../common/Interfaces";
import { isArray } from "lodash";

interface SelfState {
    value: any | number[],
    additionalModel: any
}

interface SelfProps {
    additionalModel: any,
    readonly?: boolean
}

export default class BasicCustomField extends React.Component<FieldProps & SelfProps, SelfState> {
    constructor(props: any) {
        super(props);

        this.state = {
            value: this.props.value,
            additionalModel: this.props.additionalModel
        }
    }

    isActiveValue = (value: number) => {
        if (isArray(this.state.value)) {
            return this.state.value.some(v => v === value);
        }
        return this.state.value === value
    }

    onChange = (value: any) => {
        if (this.props.readonly)
            return;

        this.setState({ value: value });
        this.props.onChange(value);
    }

    getInputClasses = (value: number) => {
        let classes = [`step-input-item`]
        if (this.isActiveValue(value)) {
            classes.push('active')
        }
        return classes.join(' ')
    }
}